export default __webpack_public_path__ + "static/media/logo-colored.fe96b8a9.svg";